/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the IntegrationStatus interface.
 */
export function instanceOfIntegrationStatus(value) {
    if (!('key' in value) || value['key'] === undefined)
        return false;
    if (!('label' in value) || value['label'] === undefined)
        return false;
    if (!('configured' in value) || value['configured'] === undefined)
        return false;
    return true;
}
export function IntegrationStatusFromJSON(json) {
    return IntegrationStatusFromJSONTyped(json, false);
}
export function IntegrationStatusFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'key': json['key'],
        'label': json['label'],
        'configured': json['configured'],
        'detail': json['detail'] == null ? undefined : json['detail'],
    };
}
export function IntegrationStatusToJSON(json) {
    return IntegrationStatusToJSONTyped(json, false);
}
export function IntegrationStatusToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'key': value['key'],
        'label': value['label'],
        'configured': value['configured'],
        'detail': value['detail'],
    };
}
